import { PAYMENT_ENDPOINTS } from '../../../utils/api/endpoints/paymentEndpoints';
import {
  UseSignatureConsultPUBParams,
  UseSignatureConsultPUBResponse,
} from './useSignatureConsultPUB.types';

const PREFIX = '[signatureConsultPUBQuery]';

export const querySignatureConsultPUB = async (params: UseSignatureConsultPUBParams) => {
  console.log(PREFIX, `Fetching signature consult PUB...`);
  const response = await PAYMENT_ENDPOINTS.signatureConsultPUB(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received signature consult PUB.`);
  return json as UseSignatureConsultPUBResponse;
};
